<div class="InsertHyperlinkDialog d-felx flex-column">
  <form [formGroup]="inputForm">
    <div class="InsertHyperlinkDialog__item flex-grow-1">
      <app-text-field
        placeholder="Enter link content"
        formControlName="content"></app-text-field>
    </div>
    <div class="InsertHyperlinkDialog__item flex-grow-1">
      <app-text-field
        placeholder="Enter link url"
        formControlName="url"></app-text-field>
    </div>
    <div class="InsertHyperlinkDialog__item flex-grow-1">
      <app-select
        [label]="selectTargetProperties.label"
        [items]="selectTargetProperties.items"
        [defaultValue]="'_blank'"
        formControlName="target"></app-select>
    </div>
  </form>
</div>
